const toggleClass = (container) => {
  container.classList.toggle("active");
};

document.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector(".pottd-socials-container");

  if (container !== null) {
    const buttons = document.querySelectorAll(".social-button");

    const instagramContainer = document.querySelector(
      ".social-widget-wrapper.instagram"
    );

    const tiktokContainer = document.querySelector(
      ".social-widget-wrapper.tiktok"
    );

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        buttons.forEach((otherButton) =>
          otherButton.classList.remove("active")
        );
        if (button.classList.contains("instagram")) {
          instagramContainer.classList.add("active");
          tiktokContainer.classList.remove("active");
        } else {
          tiktokContainer.classList.add("active");
          instagramContainer.classList.remove("active");
        }

        button.classList.add("active");
      });
    });
  }
});
